import React from "react";
import {
  MoneyBackIcon,
  FreeShippingIcon,
  DollarCircleIcon,
  FreeShippingTrialProductIcon,
} from "@/components/icons";

export interface ProductBenefitsProps {
  isTrialProduct: boolean;
}

export function ProductBenefits({ isTrialProduct }: ProductBenefitsProps) {
  return (
    <div className="mt-6 flex justify-center space-x-4">
      <div className="flex items-center space-x-2">
        {isTrialProduct ? (
          <>
            <DollarCircleIcon />
            <p className="body text-[13px] lg:text-sm">
              <strong>25% off</strong> all recurring orders of these products
            </p>
          </>
        ) : (
          <>
            <MoneyBackIcon />
            <p className="body text-[13px] lg:text-sm">
              <strong>30-day</strong> money back guarantee
            </p>
          </>
        )}
      </div>
      <div className="flex items-center space-x-2">
        {isTrialProduct ? (
          <>
            <FreeShippingTrialProductIcon />
            <p className="body text-[13px]">
              <strong>Free Shipping</strong> on this starter set!
            </p>
          </>
        ) : (
          <>
            <FreeShippingIcon />
            <p className="body text-[13px]">
              <strong>Free Shipping</strong> on orders over $35
            </p>
          </>
        )}
      </div>
    </div>
  );
}
